// @flow

import type { TokenProviderInterface } from './token-provider-interface'
import type { UserModule } from '../store/modules/user'

class StoreTokenProvider implements TokenProviderInterface {
  store: UserModule

  constructor (store: UserModule) {
    this.store = store
  }

  getToken (): string {
    return this.store.state && this.store.state.user ? this.store.state.user.token : ''
  }
}

export default StoreTokenProvider



// WEBPACK FOOTER //
// ./src/token/store-token-provider.js